'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: stretch;
  padding-bottom: 2rem !important;
  @media screen and (width > ${theme.sizes.screens.md}) {
    gap: 100px;
  }
`;
